import { ASSETS_PATH, IMAGES_PATH, LANDING_IMAGES_PATH } from 'themes'

let imageList = [
    IMAGES_PATH('/errors/serverOffline.svg'),
    IMAGES_PATH('/errors/serverError.svg'),

    IMAGES_PATH(`/ledgers/eurOval.svg`),
    IMAGES_PATH(`/ledgers/usdOval.svg`),
    IMAGES_PATH(`/ledgers/chfOval.svg`),
    IMAGES_PATH(`/ledgers/btcIcon.svg`),
    IMAGES_PATH(`/ledgers/solOval.svg`),
    IMAGES_PATH(`/ledgers/ethOval.svg`),
    IMAGES_PATH(`/ledgers/usdcOval.svg`),
    IMAGES_PATH(`/ledgers/usdtOval.svg`),

    IMAGES_PATH(`/check_circle.svg`),
    IMAGES_PATH(`/check.svg`),
    IMAGES_PATH(`/copy-icon.svg`),
    IMAGES_PATH(`/upload-documents.svg`),
    IMAGES_PATH(`/success-circle.svg`),
    IMAGES_PATH(`/success-circle-gray.svg`),
    IMAGES_PATH(`/metals.svg`),
    IMAGES_PATH(`/trading-desk-logo.svg`),
    IMAGES_PATH(`/logo.svg`),
    IMAGES_PATH(`/logoDark.svg`),
    IMAGES_PATH(`/arrowLeft.svg`),

    LANDING_IMAGES_PATH(`/logo.svg`),
    LANDING_IMAGES_PATH(`/logo_mobile.svg`),
    LANDING_IMAGES_PATH(`/bg.jpg`),
    LANDING_IMAGES_PATH(`/bg_mobile.jpg`),

    IMAGES_PATH(`/servicePlans/cards.svg`),
    IMAGES_PATH(`/servicePlans/crypto.svg`),
    IMAGES_PATH(`/servicePlans/ibans.svg`),
    IMAGES_PATH(`/servicePlans/metals.svg`),
    IMAGES_PATH(`/servicePlans/stocks.svg`),
    IMAGES_PATH(`/servicePlans/plan_bg.png`),

    IMAGES_PATH(`/crypto/btcIcon.svg`),

    ASSETS_PATH(`/images-offers/image1.png`),
    ASSETS_PATH(`/images-offers/image2.png`),
    ASSETS_PATH(`/images-offers/image3.png`),
    ASSETS_PATH(`/images-offers/image4.png`),
    ASSETS_PATH(`/images-offers/image6.png`),
    ASSETS_PATH(`/images-offers/support.png`),

    IMAGES_PATH(`/accountProfileMenu.svg`),
    IMAGES_PATH(`/businessProfile.svg`),

    IMAGES_PATH('/security-warn-fab.svg'),

    IMAGES_PATH(`/cardShowDetails.svg`),
    IMAGES_PATH(`/cardHideDetails.svg`),
    IMAGES_PATH(`/cardFreeze.svg`),
    IMAGES_PATH(`/cardUnfreeze.svg`),
    IMAGES_PATH(`/cardDeactivate.svg`),
    IMAGES_PATH(`/cardShowPin.svg`),
    IMAGES_PATH(`/cardHidePin.svg`),
]

;(window => {
    window.preloadedImages = []
    imageList.forEach(image => {
        const newImage = new Image()
        newImage.src = image
        window.preloadedImages.push(newImage)
    })
})(window)
